const invoiceDesignList = [
  {
    key: "1",
    name: "fatura.xelt",
    uploadDate: "01/01/2022",
    defaultTemplate: "True",
  },
  {
    key: "2",
    name: "fatura2.xelt",
    uploadDate: "05/01/2022",
    defaultTemplate: "True",
  },
];
export default invoiceDesignList;
